var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mt-6" },
    [
      _c("jade-box", [
        _c(
          "div",
          { staticClass: "mb-2" },
          [
            _c("JadeGroupHeader", [
              _vm._v(" " + _vm._s(_vm.$t("terminals")) + " "),
            ]),
          ],
          1
        ),
        _vm.loading
          ? _c(
              "div",
              {
                staticClass: "eu-pa_6 eu-align_center",
                attrs: { "data-testid": "show-loading" },
              },
              [_c("emd-loader", { attrs: { type: "_invert" } })],
              1
            )
          : _c(
              "div",
              [
                _vm.showEmptyList
                  ? _c("empty-list", {
                      attrs: {
                        entity: "physical-world-list",
                        svg: "pos",
                        "data-testid": "show-empty",
                      },
                    })
                  : _vm.showEmptyListFilter
                  ? _c("empty-list-filter", { attrs: { entity: "pos" } })
                  : _c(
                      "div",
                      [
                        _vm._l(_vm.items, function (item, index) {
                          return _c("terminals-list-item", {
                            key: item.id,
                            attrs: { source: item, index: index },
                          })
                        }),
                        _c(
                          "div",
                          { staticClass: "p-5" },
                          [
                            _c(
                              "jade-pagination",
                              {
                                attrs: {
                                  disabledPrevious:
                                    _vm.pagination.current_page === 1,
                                  disabledNext:
                                    _vm.pagination.current_page ===
                                    _vm.pagination.total_page,
                                },
                                on: {
                                  onPrevious: () => _vm.$emit("onPrevious"),
                                  onNext: () => _vm.$emit("onNext"),
                                },
                              },
                              [
                                _c("jade-text", [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.pagination.current_page) +
                                      " de " +
                                      _vm._s(_vm.pagination.total_page) +
                                      " "
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      2
                    ),
              ],
              1
            ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }